import RowActionMenu from "../../menu/RowActionMenu";
import { renderTableCell } from "../../../utils/commonfunctions";

export default function EnvironmentTableFields(rowActionButtons) {
    return (
       [
            {
                field: '__check__',
                hideable: false,
                sortable: false,
                filterable: false,
                minWidth: 55,
                maxWidth: 55,
                resizable: false,
                headerAlign: 'center',
                align: 'center',
            },
            {
                field: 'name',
                headerName: "Name",
                hideable: false,
                sortable: true,
                filterable: true,
                minWidth: 280,
                maxWidth: 320,
                headerAlign: 'left',
                align: 'left',
                renderCell: (params) => renderTableCell(params.value),
            },
            {
                field: 'description',
                headerName: "Description",
                hideable: false,
                sortable: true,
                filterable: true,
                flex: 1,
                headerAlign: 'left',
                align: 'left',
                renderCell: (params) => renderTableCell(params.value),
            },
            {
                field: 'Actions',
                headerName: 'Actions',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                filterable: false,
                hideable: false,
                disableColumnMenu: true,
                minWidth: 90,
                maxWidth: 90,
                renderCell: (params) => (
                    <RowActionMenu 
                        menuItems={rowActionButtons} 
                        rowData={params.row} 
                        isDisabled={false}
                    />
                ),
                resizable: false,
            },
        ] 
    )
}